import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {},
    labelEmpty: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),
      color: COLORS.neutral.mediumGray,
    },
    detectedBrandTerm: {
      '& + &': {
        marginTop: theme.spacing(2),
      },
    },
    viewMore: {
      marginTop: theme.spacing(0.5),
    },
    demoWrapper: {
      padding: theme.spacing(0, 2, 3, 4),
      border: `1px solid ${COLORS.success.default}`,
      borderRadius: theme.shape.borderRadius,
    },
    demoBadge: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: theme.spacing(0, -2, 0, -4),
      padding: theme.spacing(1, 0),
      borderTopRightRadius: theme.shape.borderRadius,
      borderTopLeftRadius: theme.shape.borderRadius,
      fontSize: theme.typography.pxToRem(10),
      lineHeight: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightBold,
      textTransform: 'uppercase',
      backgroundColor: COLORS.success.badge,
      color: COLORS.success.active,
      borderBottom: `1px solid ${COLORS.success.default}`,
    },
    demoTitle: {
      margin: theme.spacing(3, 0, 0.5),
      fontFamily: theme.typography.fontRobotoSlab,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(22),
      fontWeight: theme.typography.fontWeightBold,
    },
    demoDescription: {
      marginBottom: theme.spacing(3),
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(18),
    },
    demoBrandTerm: {
      maxWidth: 416,
      pointerEvents: 'none',
      borderColor: COLORS.neutral.lightGray,
      opacity: 0.5,
      '&:hover': {
        borderColor: COLORS.neutral.lightGray,
      },
      '& p': {
        color: COLORS.neutral.lightGray,
      },
    },
    demoActions: {
      marginTop: theme.spacing(3),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      columnGap: theme.spacing(2),
    },
    button: {},
  }),
  { name: 'DetectedBrandTermDemo' }
);
